import { EncashmentsStatusType } from 'app/dataTypes/reports/data'


export const rejectAvailable = (status: EncashmentsStatusType | null) => {
  return status === EncashmentsStatusType.WaitingForCash
}

export const acceptAvailable = (status: EncashmentsStatusType | null) => {
  return (status === EncashmentsStatusType.WaitingForCash)
}
